<div class="sign-up-form" [class.-confirmation-panel]="state === SignUpPageState.CONFIRMATION || state === SignUpPageState.SUCCESS">
  <partial-loading-indicator [isLoading]="isLoading">

    <div class="sign-up-form-panel_header">
      <span>{{pageTitle | l10n}}</span>
    </div>

    <div class="sign-up-form-panel_form">
      @switch (state) {
        @case (SignUpPageState.FORM) {
          <form [formGroup]="form" (submit)="submit()">
            @if (!useEmailAsUsername) {
              <div class="sign-up-form_field">
                <input type="text" class="sign-up-form_field_input"
                  placeholder="{{'components.sign-up-page.username' | l10n}}"
                  [formControl]="form.controls.username"
                  [autofocus]="!useEmailAsUsername"
                  materialInput />
                <div class="sign-up-form_error-message">
                  {{userIdErrorMessage | l10n}}
                </div>
              </div>
            }
            <div class="sign-up-form_field -without-error">
              <input type="text" class="sign-up-form_field_input"
                placeholder="{{'components.sign-up-page.full_name' | l10n}}"
                [formControl]="form.controls.fullName"
                [autofocus]="useEmailAsUsername"
                materialInput />
            </div>
            <div class="sign-up-form_field">
              <input type="email" class="sign-up-form_field_input"
                placeholder="{{'components.sign-up-page.email' | l10n}}"
                [formControl]="form.controls.email"
                materialInput />
              <div class="sign-up-form_error-message">
                {{emailErrorMessage | l10n}}
              </div>
            </div>
            <div class="sign-up-form_field -without-error">
              <input type="password" class="sign-up-form_field_input"
                placeholder="{{'components.sign-up-page.password' | l10n}}"
                [formControl]="form.controls.password"
                required materialInput />
            </div>
            <div class="sign-up-form_field -without-error">
              <input type="password" class="sign-up-form_field_input"
                placeholder="{{'components.sign-up-page.confirm_password' | l10n}}"
                [formControl]="form.controls.repeatPassword"
                required materialInput />
            </div>
            @if (signUpDisplayReferralIdInput) {
              <div class="sign-up-form_field -without-error">
                <input type="text" class="sign-up-form_field_input"
                  placeholder="{{'components.sign-up-page.referral_id_optional' | l10n}}"
                  [formControl]="form.controls.referralId"
                  materialInput />
              </div>
            }
            <div class="sign-up-form_error-message">
              {{errorMessage | l10n}}
            </div>
            <div class="sign-up-form_submit-wrapper">
              <button class="sign-up-form_submit-button" type="submit" [disabled]="submitting">
                <span class="sign-up-form_submit-button_text">{{'components.sign-up-page.sign_up_button_title' | l10n}}</span>
              </button>
            </div>
            <div class="sign-up-form_sign-in-wrapper">
              <a class="sign-up-form_sign-in-link" [routerLink]="['/login']">{{'components.sign-up-page.back_to_login' | l10n}}</a>
            </div>
          </form>
        }
        @case (SignUpPageState.CONFIRMATION) {
          <div class="sign-up-form_confirmation-info">
            {{'components.sign-up-page.confirmation_text_paragraph_1' | l10n:replacementData}}
          </div>
          <div class="sign-up-form_confirmation-info">
            {{'components.sign-up-page.confirmation_text_paragraph_2' | l10n:replacementData}}
          </div>
          <div class="sign-up-form_submit-wrapper">
            <div class="sign-up-form_back-link-wrapper">
              <a class="sign-up-form_back-link" [routerLink]="['/login']">{{'components.sign-up-page.back_to_login'
              | l10n}}</a>
            </div>
          </div>
        }
        @case (SignUpPageState.SUCCESS) {
          <div class="sign-up-form_confirmation-info">
            {{'components.sign-up-page.success_text_paragraph_1' | l10n:replacementData}}
          </div>
          <div class="sign-up-form_confirmation-info">
            {{'components.sign-up-page.success_text_paragraph_2' | l10n:replacementData}}
          </div>
          <div class="sign-up-form_submit-wrapper">
            <div class="sign-up-form_back-link-wrapper">
              <a class="sign-up-form_back-link" [routerLink]="['/login']">{{'components.sign-up-page.back_to_login'
              | l10n}}</a>
            </div>
          </div>
        }
      }
    </div>

  </partial-loading-indicator>
</div>
